<template>
  <div>
    <!--Charts-->
    <div class="row">
      <ListadoPolizas></ListadoPolizas>
    </div>
  </div>
</template>
<script>
import {ListadoPolizas} from "@/components";

export default {
  components: {
    ListadoPolizas
  },
  data() {
    return {};
  }
};
</script>
<style>
</style>
